import axios from 'axios';

const getBroadcast = async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/broadcasts`);

  return response.data;
}

const updateBroadcast = async ({ broadcastData }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/broadcasts`, {
    ...broadcastData
  });

  return response.data;
}

const broadcastService = {
  getBroadcast,
  updateBroadcast
};

export default broadcastService;
